import React from 'react'
import './Road.css'

function Road() {
  return (
      <div className="road-services-container">
      {/* Hero section with image and overlay text */}
      <div className="road-services-hero">
        <div className="road-services-overlay">
          <h1>Road</h1>
        </div>
      </div>
      
      {/* White gap */}
      <div className="white-gap"></div>
       {/* Content section with image and text */}
      <div className="road-content">
        <div className="road-image">
          <img src="/Pics/road.jpg" alt="Full Logistics Services" />
        </div>
        
        <p>
          The Road Freight division at Centrex marine services offers our customers comprehensive and convenient soluons for transporng full and paral truckloads across Pakistan. We have established strong partnerships with a diverse network of professional transport companies, enabling us to select the ideal partner for each unique transportaon job based on your specific requirements.
        </p>
        
        <p>
          Our Less than Truckload (LTL) services are an excellent choice for shipments that don't require a full truck. This opon allows you to transport smaller quanes or unusually shaped consignments without incurring the expenses associated with booking an enre truck.
        </p>
        
        <p>
        Alternavely, if you need to transport a substanal volume of goods, our Full Truck Load (FTL) services are enrely customizable to suit your needs. We offer direct shipping to your designated delivery point, ensuring efficient and secure transportaon. We can even deploy dual drivers for your FTL shipments to enhance security and expedite transit mes.
        </p>
        
        <p>
       Centrex marine services paves the way for the clientele to have seamless and reliable road freight services that cater to each of the transportaon needs with precision. The team at Centrex marine services is trained to follow along to understand the importance of efficient land-based logiscs, ensuring that cargo reaches its final desnaon on me and in opmal condion.
        </p>
        
        <p>
        We also offer a range of value-added services such as real-me tracking, temperature-controlled transportaon, and dedicated customer support to ensure your cargo reaches its desnaon reliably and on me. Trust us as your one-stop road freight partner in Pakistan, where reliability, flexibility, and professionalism are our hallmarks.
        </p>
        
      </div>
      </div>
  )
}

export default Road